import React from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import { FaUsers, FaComments, FaHandsHelping, FaChartLine } from 'react-icons/fa';

const CommunityBoard = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0 }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header />
      
      <motion.div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Hero Section */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <h1 className="text-2xl md:text-4xl font-bold bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-transparent">
            Community Board
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Connect with other users and share your financial journey
          </p>
        </motion.div>
        
        <motion.div 
          className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6"
          variants={itemVariants}
        >
          <div className="space-y-6">
            <motion.div variants={itemVariants} className="text-center py-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Coming Soon
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-8">
                We're working on building an amazing community space for you.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg shadow transition-all duration-300 hover:shadow-lg">
                  <FaUsers className="h-10 w-10 mx-auto text-indigo-500" />
                  <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">Share Financial Tips</h3>
                  <p className="mt-2 text-gray-600 dark:text-gray-400">Exchange strategies and advice with others on similar financial journeys</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg shadow transition-all duration-300 hover:shadow-lg">
                  <FaComments className="h-10 w-10 mx-auto text-purple-500" />
                  <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">Ask Questions</h3>
                  <p className="mt-2 text-gray-600 dark:text-gray-400">Get guidance and advice from the community on your financial concerns</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg shadow transition-all duration-300 hover:shadow-lg">
                  <FaHandsHelping className="h-10 w-10 mx-auto text-pink-500" />
                  <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">Connect with Others</h3>
                  <p className="mt-2 text-gray-600 dark:text-gray-400">Build relationships with like-minded individuals on similar financial paths</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-700 p-6 rounded-lg shadow transition-all duration-300 hover:shadow-lg">
                  <FaChartLine className="h-10 w-10 mx-auto text-indigo-500" />
                  <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">Success Stories</h3>
                  <p className="mt-2 text-gray-600 dark:text-gray-400">Learn from others who have achieved their financial goals</p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default CommunityBoard;
